import { ChangeEvent } from 'react'

const rgNumberFormater = (input: HTMLInputElement) => {
  const value = input.value.replace(/\D/g, '')
  if (value.length === 9)
    input.value = `${value.slice(0, 8)}-${value.slice(8, 9)}`
  else input.value = value
}

export const rgMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    rgNumberFormater(event.target)
  }
}
